import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export interface SelectOption { value: string; label: string; }

let uid = 0;

/** <cadence-select label="…" .options=${[{value,label}]} value> emits `change` with the value. */
@customElement('cadence-select')
export class CadenceSelect extends LitElement {
  @property() label = '';
  @property() value = '';
  @property() placeholder = '';
  @property({ type: Array }) options: SelectOption[] = [];
  private selectId = `cadence-select-${++uid}`;

  static styles = css`
    :host { display: block; }
    .field { display: flex; flex-direction: column; gap: 6px; }
    label { font-size: 0.85rem; font-weight: 600; color: var(--color-text-secondary); }
    select {
      font: inherit; padding: 10px 12px; border-radius: var(--radius-md);
      border: 1px solid var(--color-border); background: var(--color-bg-primary);
      color: var(--color-text-primary); cursor: pointer;
    }
    select:focus { outline: none; border-color: var(--color-primary); box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-primary) 25%, transparent); }
  `;

  private onChange(e: Event) {
    e.stopPropagation();
    this.value = (e.target as HTMLSelectElement).value;
    this.dispatchEvent(new CustomEvent('change', { detail: this.value, bubbles: true, composed: true }));
  }

  render() {
    return html`
      <div class="field">
        ${this.label ? html`<label for=${this.selectId}>${this.label}</label>` : ''}
        <select id=${this.selectId} .value=${this.value} @change=${this.onChange}>
          ${this.placeholder ? html`<option value="" ?selected=${!this.value}>${this.placeholder}</option>` : ''}
          ${this.options.map((o) => html`<option value=${o.value} ?selected=${o.value === this.value}>${o.label}</option>`)}
        </select>
      </div>
    `;
  }
}
